module.exports = __webpack_public_path__ + "static/media/iconErrorDialog.d323d80d.svg";